import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api } from '../api'

interface CaseItem {
  id: number
  title: string
  slug: string
  thumbnail: string
  is_published: number
  sort_order: number
  publish_date: string
  industry_name: string
  region_name: string
}

export default function CasesPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [list, setList] = useState<CaseItem[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [keyword, setKeyword] = useState(searchParams.get('keyword') || '')
  const page = parseInt(searchParams.get('page') || '1')
  const pageSize = 20

  const fetchList = async () => {
    setLoading(true)
    const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) })
    if (keyword) params.set('keyword', keyword)

    const res = await api.get(`/api/admin/cases?${params}`)
    if (res.success) {
      setList(res.data.list)
      setTotal(res.data.pagination.total)
    }
    setLoading(false)
  }

  useEffect(() => { fetchList() }, [page])

  const handleSearch = () => {
    setSearchParams({ keyword, page: '1' })
    fetchList()
  }

  const handleDelete = async (id: number) => {
    if (!confirm('确定要删除这个案例吗？')) return
    const res = await api.delete(`/api/admin/cases/${id}`)
    if (res.success) fetchList()
  }

  const totalPages = Math.ceil(total / pageSize)

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">客户案例</h1>
        <Link to="/cases/new" className="btn btn-primary">+ 新增案例</Link>
      </div>

      <div className="search-bar">
        <input
          className="form-input"
          placeholder="搜索标题..."
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
        />
        <button className="btn btn-outline" onClick={handleSearch}>搜索</button>
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>标题</th>
            <th>行业</th>
            <th>地区</th>
            <th>状态</th>
            <th>排序</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={7} style={{ textAlign: 'center' }}>加载中...</td></tr>
          ) : list.length === 0 ? (
            <tr><td colSpan={7} style={{ textAlign: 'center' }}>暂无数据</td></tr>
          ) : (
            list.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.title}</td>
                <td>{item.industry_name || '-'}</td>
                <td>{item.region_name || '-'}</td>
                <td>
                  <span className={`badge ${item.is_published ? 'badge-success' : 'badge-secondary'}`}>
                    {item.is_published ? '已发布' : '未发布'}
                  </span>
                </td>
                <td>{item.sort_order}</td>
                <td>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <Link to={`/cases/${item.id}/edit`} className="btn btn-outline btn-sm">编辑</Link>
                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item.id)}>删除</button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="pagination">
          <button disabled={page <= 1} onClick={() => setSearchParams({ page: String(page - 1), keyword })}>
            上一页
          </button>
          <span>第 {page} / {totalPages} 页</span>
          <button disabled={page >= totalPages} onClick={() => setSearchParams({ page: String(page + 1), keyword })}>
            下一页
          </button>
        </div>
      )}
    </div>
  )
}
